import React from 'react';

import { appNamedRoutes } from 'routes';

import PageSubNav from 'components/nav/PageSubNav';

const LIBRARY_PAGES = [
  {
    path: appNamedRoutes.cardsLibrary,
    label: 'Activity Cards',
  },
  {
    path: appNamedRoutes.programContentLibrary,
    label: 'Tips',
  },
];


const LibrarySubNav = () => {
  return (
    <PageSubNav items={LIBRARY_PAGES} />
  );
};

export default LibrarySubNav;
